import React from 'react';
import { InlineEditableText } from 'components/DesignSystems/InlineEditableText/InlineEditableText';
import type { GeoLocation } from './buildGeoLocationFromGeoJson';

export type LocationSummaryProps = {
  location: GeoLocation;
  readOnly?: boolean;
  onSaveName: (name: string) => void;
  onSaveAddress: (address: string) => void;
};

export const LocationSummary: React.FC<LocationSummaryProps> = ({
  location,
  readOnly = false,
  onSaveName,
  onSaveAddress,
}) => {
  return (
    <div className="m-2">
      <InlineEditableText
        label="Name"
        value={location.name || ''}
        onSave={onSaveName}
        readOnly={readOnly}
      />
      <InlineEditableText
        label="Address"
        value={location.address || ''}
        onSave={onSaveAddress}
        readOnly={readOnly}
      />
      <div className="d-flex align-items-center flex-wrap">
        <span className="fst-italic me-2">Lng/Lat:</span>
        <span className="fw-bold" data-testid="location-summary-coords">
          {(() => {
            const geometry = location?.centroid?.geometry;
            if (!geometry || geometry.type === 'GeometryCollection') {
              return '';
            }
            return JSON.stringify(geometry.coordinates);
          })()}
        </span>
      </div>
    </div>
  );
};
